export default {
  noChannels: '会話がありません',
  selectChannel: '連絡先未選択',
  connectFailed: 'チャットサービスへの接続に失敗しました。再試行してください',
  sendFailed: '送信に失敗しました。再試行してください',
  inputPlaceholder: 'メッセージを入力...',
  send: '送信',
  file: 'ファイル',
  uploadFile: 'ファイルをアップロード',
  retry: '再接続',
  searchPlaceholder: '担当者またはエージェント会社を検索',
  searchPlaceholder2: '担当者または募集企業を検索',
  newChat: '新しい会話を開始',
  filterAll: '全部',
  filterUnread: '未読',
  pin: 'ピン留め',
  unpin: 'ピン留め解除',
  markRead: '既読にする',
  markUnread: '未読にする',
  sendTo: 'に送信',
  cancel: 'キャンセル',
  contactTitle: '連絡先',
  contactSubtitle: '企業を選択すると連絡先が表示され、クリックするとチャットを開始できます。',
  noCompanies: '企業がありません',
  noPersons: '連絡先がありません',
  selectCompanyFirst: '先に企業を選択してください',
  yearsAgo: '{0}年前',
  noCoopHeadhunters: '連携中のエージェントはありません',
  noCoopEnterprises: '連携中の募集企業はありません',
  gotIt: 'OK',
  // Headhunter Chat
  headhunterChat: 'エージェントと連絡',
  companyChat: '募集企業と連絡',
  selectCompanyFirst: '企業を選択すると、連絡先を確認できます',
  coopStoppedNoMessage: '連携が終了しているため、メッセージは送信できません',
}
